import AddLocation from './AddLocation.container';

export default AddLocation;
